let lastId = 0

export const getUniqueId = (prefix = '') => `${prefix}${String(++lastId)}`
